package com.shadowings.gero.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class Characters {
    Alyn,
    Nilo,
    Zeta,
    Masko
}


